import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
function isEmptyArray(value) {
  return Array.isArray(value) && isEmpty(value);
}
export function areEmptyArrays() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  return values.every(isEmptyArray);
}
function isEmptyObject(value) {
  return isObject(value) && !Array.isArray(value) && isEmpty(value);
}
export function areEmptyObjects() {
  for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    values[_key2] = arguments[_key2];
  }
  return values.every(isEmptyObject);
}